import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Smartphone, Camera, Settings } from "lucide-react";
import { useI18n } from "@/lib/i18n";

/**
 * Phase 5 — Tiny helper shown ONLY when a user hits the HEVC/H.265 rejection.
 * Not a tutorial, just the exact 4-tap path on iPhone plus a note that new
 * recordings will be compatible with ToClean.
 */
export default function HevcHelpDialog({ open, onOpenChange }) {
  const { t } = useI18n();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="hevc-help-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Smartphone size={18} className="text-emerald-600" />
            {t("hevc_help_title")}
          </DialogTitle>
          <DialogDescription>{t("hevc_help_desc")}</DialogDescription>
        </DialogHeader>
        <ol className="space-y-2 text-sm">
          <li className="flex items-start gap-2">
            <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold flex items-center justify-center">1</span>
            <span><Settings size={13} className="inline mr-1 text-slate-500" /> {t("hevc_help_step1")}</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold flex items-center justify-center">2</span>
            <span><Camera size={13} className="inline mr-1 text-slate-500" /> {t("hevc_help_step2")}</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold flex items-center justify-center">3</span>
            <span>{t("hevc_help_step3")}</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold flex items-center justify-center">4</span>
            <span className="font-semibold">{t("hevc_help_step4")}</span>
          </li>
        </ol>
        <div className="text-xs text-slate-500 mt-2 italic">
          {t("hevc_help_note")}
        </div>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} className="rounded-full bg-emerald-600 hover:bg-emerald-700 text-white hover:text-white" data-testid="hevc-help-close">
            {t("ok") || "OK"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
